/**
 * Download File Action
 * Downloads a single file directly (not as a ZIP)
 */

import { Datum } from "../datastructure";
import { ActionDefinition, ActionContext, getFilePayload } from "./types";
import { BASE_API_URL } from "@/constants";
import fpFetch from "@/services/fpFetch";

/**
 * Downloads a single file directly
 */
export async function downloadFile(
  datum: Datum,
  context: ActionContext
): Promise<void> {
  const payload = getFilePayload(datum);
  if (!payload) {
    console.error("downloadFile: Cannot download non-file datum");
    return;
  }

  try {
    const fileUrl = `${BASE_API_URL}/userData/fp0065?fileId=${payload.fileId}&v=cacheBust8&raw=true`;
    const response = await fpFetch(fileUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = payload.fileName || "download";
    a.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("downloadFile: Failed to download file", error);
    context.showToast?.("Failed to download file", "error");
  }
}

/**
 * Action definition for context menu
 */
export const downloadFileAction: ActionDefinition = {
  config: {
    action: "download-file",
    label: "Download",
  },
  isApplicable: (datum) => datum.type === "file",
  execute: downloadFile,
};
